// src/components/DataSource.jsx
import React from 'react';
import { Globe, Mail, ExternalLink, Github, Database, Book } from 'lucide-react';

const DataSource = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-green-800 text-white mt-12">
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* SAGE Info */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="https://i.ibb.co/9pcvxh1/image-removebg-preview-1.png" 
                alt="SAGE Logo" 
                className="h-12 w-auto object-contain mr-4"
              />
            </div>
            <p className="text-gray-300 text-sm">
              Data provided by the SAGE (Smart Array of Geographically Enabled) network, 
              a project supported by the U.S. Department of Energy and Argonne National Laboratory.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://sagecontinuum.org/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white flex items-center"
                >
                  <Globe size={16} className="mr-2" />
                  SAGE Website
                </a>
              </li>
              <li>
                <a 
                  href="https://portal.sagecontinuum.org"
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white flex items-center"
                >
                  <Database size={16} className="mr-2" />
                  SAGE Portal
                </a>
              </li>
              <li>
                <a 
                  href="https://sagecontinuum.org/docs/about/overview" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white flex items-center"
                >
                  <Book size={16} className="mr-2" />
                  Documentation
                </a>
              </li>
              <li>
                <a 
                  href="https://github.com/Kaludii/environmental-nodes-dashboard-react" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white flex items-center"
                >
                  <Github size={16} className="mr-2" />
                  View Source Code
                </a>
              </li>
            </ul>
          </div>

          {/* Technical Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Technical Details</h3>
            <div className="space-y-2">
              <a 
                href="mailto:bkaludi4816@sdsu.edu"
                className="text-gray-300 hover:text-white flex items-center"
              >
                <Mail size={16} className="mr-2" />
                Contact Developer
              </a>
              <p className="text-gray-300 text-sm mt-4">
                This dashboard is built with React and Tailwind CSS, utilizing the SAGE API 
                for real-time environmental data visualization.
              </p>
              <p className="text-gray-300 text-sm mt-2">
                <a 
                  href="https://reactjs.org/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white"
                >
                  React
                </a>
                {' • '}
                <a 
                  href="https://tailwindcss.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white"
                >
                  Tailwind CSS
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-4 border-t border-green-700">
          <div className="flex justify-center">
            <p className="text-gray-300 text-sm">
              © {currentYear} Environmental Nodes Dashboard. Created by Bilal, SDSU.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default DataSource;